import Serp from './serp'

class SerpLegacy extends Serp {
  document () {
    return {
      created_at: null,
      version: null
    }
  }

  request () {
    return {
      device: 'desktop',
      hl: null,
      gl: null,
      google_domain: null,
      google_ip: null,
      num: null,
      q: null,
    }
  }

  page () {
    return {
      search: null,
      time_taken: null,
      total_results: null
    }
  }

  items () {
    return this.options.items.map(item => {
      return { ...item, type: item.type === 'natural' ? 'organic' : item.type }
    })
  }
}

export default SerpLegacy